'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsShallowCompare = require('react-addons-shallow-compare');

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

var _reactUtils = require('react-utils');

var _UIUnstyledButton = require('../../button/UIUnstyledButton');

var _UIUnstyledButton2 = _interopRequireDefault(_UIUnstyledButton);

var _UIIcon = require('../../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _UITag = require('../../tag/UITag');

var _UITag2 = _interopRequireDefault(_UITag);

var _UIBadge = require('../../badge/UIBadge');

var _UIBadge2 = _interopRequireDefault(_UIBadge);

var _UIImage = require('../../image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

var _UICheckbox = require('../../input/UICheckbox');

var _UICheckbox2 = _interopRequireDefault(_UICheckbox);

var _UIFlex = require('../../layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _UISpinner = require('../../loading/UISpinner');

var _UISpinner2 = _interopRequireDefault(_UISpinner);

var _Small = require('../../elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _OptionTypes = require('../../types/OptionTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// No-break space ensures that blank items are sized properly
var BLANK_LABEL = '\xA0';

var stopPropagation = function stopPropagation(evt) {
  evt.stopPropagation();
};

var instanceCount = 0;

exports.default = _react2.default.createClass({
  displayName: 'UITypeaheadResultsItem',

  propTypes: {
    highlighted: _react.PropTypes.bool.isRequired,
    itemComponent: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]),
    isIndeterminate: _react.PropTypes.bool.isRequired,
    isSelected: _react.PropTypes.bool.isRequired,
    message: _react.PropTypes.bool,
    onToggle: _react.PropTypes.func,
    option: _OptionTypes.OptionOrGroupType.isRequired,
    search: _react.PropTypes.instanceOf(RegExp),
    style: _react.PropTypes.object,
    toggleable: _react.PropTypes.bool.isRequired,
    _useButton: _react.PropTypes.bool,
    _useDropdownText: _react.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      highlighted: false,
      isIndeterminate: false,
      isSelected: false,
      itemComponent: 'li',
      toggleable: false,
      _useButton: true,
      _useDropdownText: true
    };
  },
  componentWillMount: function componentWillMount() {
    instanceCount += 1;
    this._checkboxId = 'uitri-checkbox-' + instanceCount;
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    // We're a pure component unless we have a custom itemRenderer (HubSpot/UIComponents#1870)
    return typeof nextProps.itemRenderer === 'function' ? true : (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
  },
  getButtonClassName: function getButtonClassName(_ref) {
    var message = _ref.message,
        option = _ref.option;

    return (0, _reactUtils.classNames)({
      'private-typeahead-result-label': !message,
      'private-typeahead-result-heading': option.options && !option.selectAll,
      uiTypeaheadResults__item: true,
      'truncate-text': !message,
      'p-y-2': message,
      'p-x-5': message
    });
  },
  getClassName: function getClassName(_ref2) {
    var highlighted = _ref2.highlighted,
        _ref2$option = _ref2.option,
        disabled = _ref2$option.disabled,
        dropdownClassName = _ref2$option.dropdownClassName;

    return (0, _reactUtils.classNames)('private-typeahead-result', dropdownClassName, {
      'private-typeahead-result--highlighted': highlighted,
      'private-typeahead-result--selectable': !disabled,
      'private-typeahead-result--disabled': disabled
    });
  },
  getLoadingIndicator: function getLoadingIndicator(computedButtonText) {
    return _react2.default.createElement(
      _UIFlex2.default,
      { align: 'center' },
      computedButtonText,
      _react2.default.createElement(_UISpinner2.default, {
        className: 'private-typeahead-result__loading-indicator',
        size: 'extra-small',
        use: 'tertiary'
      })
    );
  },
  getLabel: function getLabel(_ref3) {
    var _ref3$option = _ref3.option,
        buttonText = _ref3$option.buttonText,
        dropdownText = _ref3$option.dropdownText,
        loading = _ref3$option.loading,
        text = _ref3$option.text,
        value = _ref3$option.value,
        _useDropdownText = _ref3._useDropdownText;

    var fallbackText = text || (value == null ? '' : value.toString());
    if (_useDropdownText) {
      return dropdownText == null ? fallbackText : dropdownText;
    }

    var computedButtonText = buttonText == null ? fallbackText : buttonText;
    if (loading) {
      return this.getLoadingIndicator(computedButtonText);
    } else {
      return computedButtonText;
    }
  },
  getTitle: function getTitle(_ref4) {
    var _ref4$option = _ref4.option,
        text = _ref4$option.text,
        title = _ref4$option.title,
        value = _ref4$option.value;

    if (title === '') {
      return null;
    }
    return title || text || (value == null ? '' : value.toString());
  },
  renderHelp: function renderHelp(_ref5) {
    var _ref5$option = _ref5.option,
        disabled = _ref5$option.disabled,
        help = _ref5$option.help;

    if (help) {
      return _react2.default.createElement(
        _Small2.default,
        {
          className: 'private-typeahead-results-item__help',
          disabled: disabled,
          use: 'help'
        },
        help
      );
    }

    return null;
  },
  renderLabel: function renderLabel(_ref6, _ref7) {
    var search = _ref6.search;
    var computedLabel = _ref7.computedLabel;

    if (!computedLabel) {
      return BLANK_LABEL;
    }
    if (!search || typeof computedLabel !== 'string') {
      return computedLabel;
    }
    var searchResult = search.exec(computedLabel);
    if (!searchResult) {
      return computedLabel;
    }

    var match = searchResult[0];
    var head = computedLabel.slice(0, searchResult.index);
    var tail = computedLabel.slice(searchResult.index + match.length);
    return _react2.default.createElement(
      'span',
      null,
      head,
      _react2.default.createElement(
        'span',
        null,
        match
      ),
      tail
    );
  },
  renderItemImage: function renderItemImage(_ref8) {
    var _ref8$option = _ref8.option,
        avatar = _ref8$option.avatar,
        icon = _ref8$option.icon,
        imageUrl = _ref8$option.imageUrl;

    if (avatar) {
      return _react2.default.cloneElement(avatar, {
        className: (0, _reactUtils.classNames)(avatar.props.className, 'private-dropdown__item__decoration', 'private-dropdown__item__image')
      });
    }
    if (icon) {
      return _react2.default.createElement(_UIIcon2.default, { className: 'private-dropdown__item__decoration', name: icon });
    }
    if (imageUrl) {
      return _react2.default.createElement(_UIImage2.default, {
        className: (0, _reactUtils.classNames)('uiTypeaheadResults__image', 'private-dropdown__item__decoration', 'private-dropdown__item__image'),
        src: imageUrl
      });
    }
    return null;
  },
  renderTag: function renderTag(_ref9) {
    var tag = _ref9.option.tag;

    if (!tag) {
      return null;
    }

    return _react2.default.createElement(
      _UITag2.default,
      { inline: true, use: tag.use },
      tag.text
    );
  },
  renderBadge: function renderBadge(_ref10) {
    var badge = _ref10.option.badge;

    if (!badge) {
      return null;
    }

    if (_react2.default.isValidElement(badge)) {
      return _react2.default.cloneElement(badge, {
        className: (0, _reactUtils.classNames)(badge.props.className, 'private-dropdown__badge')
      });
    }

    // Support object params (legacy)
    return _react2.default.createElement(
      _UIBadge2.default,
      { className: 'private-dropdown__badge', use: badge.use },
      badge.text
    );
  },
  renderContent: function renderContent(_ref11) {
    var renderedItemImage = _ref11.renderedItemImage,
        renderedLabel = _ref11.renderedLabel,
        renderedTag = _ref11.renderedTag,
        renderedBadge = _ref11.renderedBadge,
        toggleable = _ref11.toggleable;

    return _react2.default.createElement(
      'span',
      { className: toggleable ? 'private-dropdown__item--toggleable' : '' },
      renderedItemImage,
      ' ',
      _react2.default.createElement(
        'span',
        { className: 'private-dropdown__item__label' },
        renderedLabel
      ),
      ' ',
      renderedTag,
      ' ',
      renderedBadge
    );
  },
  renderButton: function renderButton(_ref12, _ref13) {
    var rest = _ref12.rest;
    var computedButtonClassName = _ref13.computedButtonClassName,
        computedTitle = _ref13.computedTitle,
        renderedContent = _ref13.renderedContent,
        renderedHelp = _ref13.renderedHelp;

    return _react2.default.createElement(
      _UIUnstyledButton2.default,
      _extends({}, rest, {
        className: computedButtonClassName,
        role: 'option',
        tabIndex: -1,
        title: computedTitle
      }),
      renderedContent,
      renderedHelp
    );
  },
  renderCheckbox: function renderCheckbox(_ref14, _ref15) {
    var isIndeterminate = _ref14.isIndeterminate,
        isSelected = _ref14.isSelected,
        onToggle = _ref14.onToggle,
        option = _ref14.option,
        style = _ref14.style;
    var computedTitle = _ref15.computedTitle,
        renderedContent = _ref15.renderedContent,
        renderedHelp = _ref15.renderedHelp;

    return _react2.default.createElement(
      'label',
      { // Route clicks on help text to checkbox
        style: { cursor: 'pointer' },
        onMouseDown: stopPropagation // Prevent double-toggle
      },
      _react2.default.createElement(
        _UICheckbox2.default,
        {
          className: 'private-typeahead-result-label',
          checked: isSelected,
          disabled: option.clearableValue === false,
          id: this._checkboxId,
          indeterminate: isIndeterminate,
          onChange: onToggle,
          style: style,
          title: computedTitle
        },
        renderedContent
      ),
      renderedHelp
    );
  },
  render: function render() {
    var _props = this.props,
        highlighted = _props.highlighted,
        isIndeterminate = _props.isIndeterminate,
        isSelected = _props.isSelected,
        Item = _props.itemComponent,
        message = _props.message,
        onToggle = _props.onToggle,
        option = _props.option,
        search = _props.search,
        style = _props.style,
        toggleable = _props.toggleable,
        _useButton = _props._useButton,
        _useDropdownText = _props._useDropdownText,
        rest = _objectWithoutProperties(_props, ['highlighted', 'isIndeterminate', 'isSelected', 'itemComponent', 'message', 'onToggle', 'option', 'search', 'style', 'toggleable', '_useButton', '_useDropdownText']);

    var computedItemClassName = this.getClassName({ highlighted: highlighted, option: option });
    var computedButtonClassName = this.getButtonClassName({
      message: message,
      option: option
    });
    var computedTitle = this.getTitle({ option: option });
    var computedLabel = this.getLabel({ option: option, _useDropdownText: _useDropdownText });
    var renderedItemImage = this.renderItemImage({ option: option });
    var renderedLabel = this.renderLabel({ search: search }, { computedLabel: computedLabel });
    var renderedTag = this.renderTag({ option: option });
    var renderedBadge = this.renderBadge({ option: option });
    var renderedHelp = this.renderHelp({ option: option, toggleable: toggleable });

    var renderedContent = this.renderContent({
      renderedItemImage: renderedItemImage,
      renderedLabel: renderedLabel,
      renderedTag: renderedTag,
      renderedBadge: renderedBadge,
      toggleable: toggleable
    });

    // If _useButton={true}, wrap content in a button
    renderedContent = _useButton ? this.renderButton({ rest: rest }, {
      computedButtonClassName: computedButtonClassName,
      computedTitle: computedTitle,
      renderedContent: renderedContent,
      renderedHelp: renderedHelp
    }) : renderedContent;

    // If toggleable={true}, wrap content in a checkbox
    renderedContent = toggleable ? this.renderCheckbox({ isIndeterminate: isIndeterminate, isSelected: isSelected, onToggle: onToggle, option: option, style: style }, { computedTitle: computedTitle, renderedContent: renderedContent, renderedHelp: renderedHelp }) : renderedContent;

    if (typeof Item === 'function') {
      return _react2.default.createElement(
        Item,
        _extends({}, rest, {
          option: option,
          className: computedItemClassName,
          'data-option-value': option.value
        }),
        renderedContent
      );
    }
    return _react2.default.createElement(
      Item,
      {
        className: computedItemClassName,
        'data-option-value': option.value,
        role: 'presentation'
      },
      renderedContent
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/typeahead/results/UITypeaheadResultsItem.js
// module id = 157
// module chunks = 0